import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IndexmanagerService } from 'src/app/services/indexmanager.service';

@Component({
  selector: 'app-compliance-index-manager',
  templateUrl: './compliance-index-manager.component.html',
  styleUrls: ['./compliance-index-manager.component.scss']
})

export class ComplianceIndexManagerComponent implements OnInit {
  language = JSON.parse(localStorage.getItem('language'))
  titleDropdown = 'รายชื่ือผู้จัดการกองทุน'
  valueDropdown = [
    {
      id: 1,
      value: 'รายชื่อผู้จัดการกองทุน'
    },
    {
      id: 2,
      value: 'รายงานธุรกรรมกับบุคคลที่เกี่ยวข้อง'
    },
    {
      id: 3,
      value: 'แนวทางการใช้สิทธิออกเสียงในที่ประชุมผู้ถือหุ้น'
    },
    {
      id: 4,
      value: 'รายงานสรุปเกี่ยวกับการใช้สิทธิออกเสียง'
    },
    {
      id: 5,
      value: 'รายงานการถือหน่วยลงทุนเกิน 1 ใน 3'
    },
    {
      id: 6,
      value: 'รายชื่อบุคลากรที่ได้รับมอบหมายให้แนะนำการลงทุนผ่านสื่อหรืองานสัมมนา'
    }
  ];
  private navigateTo: any
  choiceFromSelect: string
  newsDate: any;

  totalNewsPage_announce: number;
  announce: any;
  renderAnnounce: any;
  newsCurrentPage_announce = 1;

  flag: any

  constructor(private route: ActivatedRoute, private _indexmanagerService: IndexmanagerService) { }

  ngOnInit() {
    this.flag = localStorage.getItem('language_flag')

    this.navigateTo = this.route.params.subscribe(params => {
      if (params['type'] === 'option1') {
        this.choiceFromSelect = params['type']

        this._indexmanagerService.get_managerList().subscribe(response => {
          this.announce = response;
          this.totalNewsPage_announce = this.setTotalNewsPage_announce(this.announce);
          this.setRenderNewsPerpage_announce(this.announce);
        })
      } else if (params['type'] === 'option2') {
        this.choiceFromSelect = params['type']
        this._indexmanagerService.get_transactionList().subscribe(response => {
          this.announce = response;
          this.totalNewsPage_announce = this.setTotalNewsPage_announce(this.announce);
          this.setRenderNewsPerpage_announce(this.announce);
        })
      } else if (params['type'] === 'option3') {
        this.choiceFromSelect = params['type']

        this._indexmanagerService.get_guidelineList().subscribe(response => {
          this.announce = response;
          this.totalNewsPage_announce = this.setTotalNewsPage_announce(this.announce);
          this.setRenderNewsPerpage_announce(this.announce);
        })
      } else if (params['type'] === 'option4') {
        this.choiceFromSelect = params['type']

        this._indexmanagerService.get_voteList().subscribe(response => {
          this.announce = response;
          this.totalNewsPage_announce = this.setTotalNewsPage_announce(this.announce);
          this.setRenderNewsPerpage_announce(this.announce);
        })
      } else if (params['type'] === 'option5') {
        this.choiceFromSelect = params['type']

        this._indexmanagerService.get_holdingInvestUnitList().subscribe(response => {
          this.announce = response;
          this.totalNewsPage_announce = this.setTotalNewsPage_announce(this.announce);
          this.setRenderNewsPerpage_announce(this.announce);
        })
      } else if (params['type'] === 'option6') {
        this.choiceFromSelect = params['type']

        this._indexmanagerService.get_assignedPersonnelList().subscribe(response => {
          this.announce = response;
          this.totalNewsPage_announce = this.setTotalNewsPage_announce(this.announce);
          this.setRenderNewsPerpage_announce(this.announce);
        })
      }
    })
  }

  setTotalNewsPage_announce(announceList) {
    if (announceList.length <= 10) {
      return 1;
    } else {
      return Math.ceil(announceList.length / 10);
    }
  }

  setRenderNewsPerpage_announce(announceList) {
    if (announceList === undefined) {
      return null;
    } else {
      this.renderAnnounce = announceList.slice(this.newsCurrentPage_announce * 10 - 10,
        this.newsCurrentPage_announce * 10);
    }
  }

  setCurrentNewsPage_announce(event) {
    this.newsCurrentPage_announce = event;
    this.setRenderNewsPerpage_announce(this.announce);
  }

  changeFormatDate_dd(date) {
    if (date === '') {
      return null;
    } else {
      return this.newsDate = this._indexmanagerService.changeFormatDate_dd(date);
    }
  }

  changeFormatDate_mm(date) {
    if (date === '') {
      return null;
    } else {
      return this.newsDate = this._indexmanagerService.changeFormatDate_MM(date);
    }
  }

  changeFormatDate_yy(date) {
    if (date === '') {
      return null;
    } else {
      return this.newsDate = this._indexmanagerService.changeFormatDate_yy(date);
    }
  }

  date_thai_dd(date) {
    if (date === '') {
      return null;
    } else {
      return this.newsDate = this._indexmanagerService.date_thai_dd(date);
    }
  }

  date_thai_mm(date) {
    if (date === '') {
      return null;
    } else {
      return this.newsDate = this._indexmanagerService.date_thai_mm(date);
    }
  }

  date_thai_yy(date) {
    if (date === '') {
      return null;
    } else {
      return this.newsDate = this._indexmanagerService.date_thai_yy(date);
    }
  }

  selectValue(event) {
    if (event === 1) {
      this._indexmanagerService.get_managerList().subscribe(response => {
        this.announce = response;
        this.totalNewsPage_announce = this.setTotalNewsPage_announce(this.announce);
        this.setRenderNewsPerpage_announce(this.announce);
      })
    } else if (event === 2) {
      this._indexmanagerService.get_transactionList().subscribe(response => {
        this.announce = response;
        this.totalNewsPage_announce = this.setTotalNewsPage_announce(this.announce);
        this.setRenderNewsPerpage_announce(this.announce);
      })
    } else if (event === 3) {
      this._indexmanagerService.get_guidelineList().subscribe(response => {
        this.announce = response;
        this.totalNewsPage_announce = this.setTotalNewsPage_announce(this.announce);
        this.setRenderNewsPerpage_announce(this.announce);
      })
    } else if (event === 4) {
      this._indexmanagerService.get_voteList().subscribe(response => {
        this.announce = response;
        this.totalNewsPage_announce = this.setTotalNewsPage_announce(this.announce);
        this.setRenderNewsPerpage_announce(this.announce);
      })
    } else if (event === 5) {
      this._indexmanagerService.get_holdingInvestUnitList().subscribe(response => {
        this.announce = response;
        this.totalNewsPage_announce = this.setTotalNewsPage_announce(this.announce);
        this.setRenderNewsPerpage_announce(this.announce);
      })
    }
  }
}
